import React, {Fragment} from 'react';
import ReactDOM from 'react-dom';
import Icon from '../../../../core/scripts/components/Icon';

export function Header() {
  return (
    <div className="headline">
      <h1 className="title">Weiße Weihnachten in ...?</h1>
      <h3 className="introtext">Alle Jahre wieder fragen wir uns, ob es an Heiligabend und an den Feiertagen schneien wird. Geben Sie Ihren Wohnort ein und sehen Sie, wann es bei Ihnen in den letzten 70 Jahren weiße Weihnachten gab. Das dekorative Ergebnis können Sie herunterladen, ausdrucken und vielseitig einsetzen: als Poster, Last-Minute-Geschenkpapier oder Grußkarte.</h3>
    </div>
  );
}
export function Samples() {
  return (
    <div className="sample">
      <div className="sample-intro">Drucken Sie die Grafik aus, beispielsweise als:</div>
      <div className="sample-items">
        <div className="sample-item"><Icon type="poster" /> <span className="sample-label">Poster</span></div>
        <div className="sample-item"><Icon type="gift" /> <span className="sample-label">Geschenkpapier</span></div>
        <div className="sample-item"><Icon type="postcard" /> <span className="sample-label">Postkarte</span></div>
      </div>
    </div>
  );
}

export function Legend() {
  return (
    <div className="legend">
      <div className="legend-item"><Icon type="tree_nosnow" /> <span className="legend-label">gar kein Schnee</span></div>
      <div className="legend-item"><Icon type="tree_somesnow" /> <span className="legend-label">wenigstens 1 x Schnee</span></div>
      <div className="legend-item"><Icon type="tree_snow" /> <span className="legend-label">alle Tage Schnee</span></div>
    </div>
  );
}
